import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { WeekFilter, MonthFilter, LocationFilter, StatusFilter } from './components/index';
import classes from './TNEFilters.module.scss';
import DayFilter from './components/DayFilter/DayFilter';
import { appAreas, tAndEFilters } from '../../../../utils/constants';
import ContractorFilter from './components/ContractorFilter/ContractorFilter';
import ClaimFilter from './components/ClaimFilter/ClaimFilter';

export default function TNEFilters(props) {
  const { filters, values, changeHandlers, part = appAreas.TIMESHEETS } = props;

  const { t } = useTranslation();

  const filtersOptions = useSelector((state) => state.filtersOptionsFromApi.filters);
  const isApprover = useSelector((state) => state.accessToParts.tAndEApprover);

  const [locations, setLocations] = useState([t('common.general.all')]);
  const [filterMonths, setFilterMonths] = useState(null);
  const [years, setYears] = useState([[]]);
  const [avaliableStatuses, setAvaliableStatuses] = useState([]);
  const [contractors, setContractors] = useState([t('common.general.all')]);
  const [claims, setClaims] = useState([t('common.general.all')]);

  const getListsForFilters = async () => {
    switch (part) {
      case appAreas.TIMESHEETS: {
        setLocations(
          [t('common.general.all'), ...filtersOptions.Locations.map((item) => item.Name)].filter((list) => list !== '')
        );
        setYears(filtersOptions.Years.map((item) => item.Year));
        setAvaliableStatuses(filtersOptions.Status.map((item) => item.Status));
        if (isApprover) setContractors([...filtersOptions.Contractors]);
        break;
      }
      case appAreas.EXPENSES: {
        setYears(filtersOptions.Years.map((item) => item.Year));
        setFilterMonths(filtersOptions.Months.map((item) => item.Month));
        setAvaliableStatuses(filtersOptions.Status.map((item) => item.Status));
        if (isApprover) setContractors([...filtersOptions.Contractors]);
        setClaims([...filtersOptions.ClaimNames]);
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    getListsForFilters();
  }, [isApprover, filtersOptions]);

  const getFilter = (filter) => {
    switch (filter) {
      case tAndEFilters.DAY:
        return <DayFilter key={tAndEFilters.DAY} day={values.day} changeDay={changeHandlers.handleDay} />;
      case tAndEFilters.WEEK:
        return <WeekFilter key={tAndEFilters.WEEK} week={values.start} changeWeek={changeHandlers.handleWeek} />;
      case tAndEFilters.MONTH:
        return (
          <MonthFilter
            key={tAndEFilters.MONTH}
            filterMonths={filterMonths}
            years={years}
            selectedMonth={values.month}
            selectedYear={values.year}
            changeMonth={changeHandlers.handleMonth}
            changeYear={changeHandlers.handleYear}
          />
        );
      case tAndEFilters.CONTRACTOR:
        return (
          <ContractorFilter
            key={tAndEFilters.CONTRACTOR}
            contractors={contractors}
            selectedContractor={values.contractor}
            changeContractor={changeHandlers.handleContractor}
          />
        );
      case tAndEFilters.CLAIM:
        return (
          <ClaimFilter
            key={tAndEFilters.CLAIM}
            claims={claims}
            selectedClaim={values.claim}
            changeClaim={changeHandlers.handleClaim}
          />
        );
      case tAndEFilters.LOCATION:
        return (
          <LocationFilter
            key={tAndEFilters.LOCATION}
            locations={locations}
            selectedLocation={values.location || t('common.general.all')}
            changeLocation={changeHandlers.handleLocation}
          />
        );
      case tAndEFilters.STATUS:
        return (
          <StatusFilter
            key={tAndEFilters.STATUS}
            selectedStatus={values.status || t('common.general.all')}
            changeStatus={changeHandlers.handleStatus}
            isApprover={isApprover}
            avaliableStatuses={avaliableStatuses}
          />
        );
      default:
        break;
    }
    return false;
  };

  return (
    <div className={classes.container}>
      {filters.map((filter) => {
        return getFilter(filter);
      })}
    </div>
  );
}
